import React, { Component } from 'react';
import { Card, Feed, Button, Icon, Grid, Popup, Input, Image, Pagination } from 'semantic-ui-react'
import Paper from '@material-ui/core/Paper';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import './style.css';
import Edit from './edit';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Mrphistory from './mrphistory';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddSpare from './addspare';
import MenuDialog from './menudialog';

class View extends Component {

  state = {
    dialog: false, fullWidth: true, maxWidth: 'lg', val: 1,
    page: 0, data: this.props.data, sort: 'asc', search: null,
    load: false, message: '', editDialog: false, openDialog: false,
    hiddenColumnArray: [2, 3, 6, 7, 8, 9, 10, 13, 14],
  }

  callChildMethod() {
    let context = this;
    $(document).ready(function() {
      setTimeout(function(){
        let temp = context.state.hiddenColumnArray;
        temp.map((x) => {
          x = x + 1;
          $('#emp_table td:nth-child('+x+')').hide();
          $('#emp_table th:nth-child('+x+')').hide();
        });
      }, 50);
      $(".hidecol").click(function(){
        var id = this.id;
        var splitid = id.split("_");
        var colno = splitid[1];
        var checked = true;
        if($(this).is(":checked")) {
          checked = false;
        }
        else{
          checked = true;
        }
        setTimeout(function(){
          if(checked){
            $('#emp_table td:nth-child('+colno+')').hide();
            $('#emp_table th:nth-child('+colno+')').hide();
          } else{
            $('#emp_table td:nth-child('+colno+')').show();
            $('#emp_table th:nth-child('+colno+')').show();
          }
        });
      });
    });
  }

  componentDidMount(val) {
    let context = this;
    $(document).ready(function() {
      setTimeout(function(){
        let temp = context.state.hiddenColumnArray;
        console.log(temp);
        temp.map((x) => {
          x = x + 1;
          $('#emp_table td:nth-child('+x+')').hide();
          $('#emp_table th:nth-child('+x+')').hide();
        });
      });
      $(".hidecol").click(function(){
        var id = this.id;
        var splitid = id.split("_");
        var colno = splitid[1];
        var checked = true;
        if($(this).is(":checked")) {
          checked = false;
        }
        else{
          checked = true;
        }
        setTimeout(function(){
          if(checked){
            $('#emp_table td:nth-child('+colno+')').hide();
            $('#emp_table th:nth-child('+colno+')').hide();
          } else{
            $('#emp_table td:nth-child('+colno+')').show();
            $('#emp_table th:nth-child('+colno+')').show();
          }
        });
      });
    });
    if (val) {
    }
    else {
      this.columnView(this.state.val);
    }
    this.callChildMethod();
  }

  onChangeHiddenColumn = (val) => event => {
    if (event.target.checked) { this.remove(val); }
    else { this.add(val); }
  }

  remove(value) {
    let hiddenColumnArray = this.state.hiddenColumnArray;
    let items = [];
    for (var i = 0; i < hiddenColumnArray.length; i++) {
      if (hiddenColumnArray[i] != value) {
        items.push(hiddenColumnArray[i]);
      }
    }
    this.setState({ hiddenColumnArray: items })
  }

  add(value) {
    let hiddenColumnArray = this.state.hiddenColumnArray;
    hiddenColumnArray.push(value);
    this.setState({ hiddenColumnArray: hiddenColumnArray })
  }

  componentDidUpdate(props) {
    if (props.data != this.props.data) {
      this.setState({ data: this.props.data })
    }
    this.callChildMethod();
  }

  sortData(val) {
    if (this.state.sort == 'desc') {
      this.props.getAllSpareDetails(1, val, 'desc');
      this.setState({ sort: 'asc' })
    }
    else {
      this.props.getAllSpareDetails(1, val, 'asc');
      this.setState({ sort: 'desc' })
    }
  }

  onChangeText() {
    let search = document.getElementById('search').value;
    this.setState({ search: search })
  }

  exportData() { 
    if (!this.props.menuPermission.exports) {
      alert('You Are Not Alllow To Export!!!');
      return;
    }
    window.location = Server() + 'spares/export.php?search='+this.state.search; 
  }

  uploadtax = (e) => {
    let context = this;
    let file = e.target.files[0];
    if (!file) { return; }
    var formData = new FormData();
    formData.append('file', file);
    context.setState({ load: true, openDialog: false  });
    $.ajax({
      type: 'POST', processData: false,
      contentType: false, data: formData,
      url: Server() + 'spares/uploadtax.php',
      success: function(data) {
        console.log(data);
        context.setState({ load: false});
        if (data == 1) {
          alert('Success');
        } else {
          alert('Failed');
        }
      },
      error: function(error) {
        context.setState({ load: false });
      }
    });
  }

  importData = (e) => {
    let context = this;
    let file = e.target.files[0];
    if (!file) {
      return;
    }
    context.setState({ load: true, message: 'File Uploading!!!' });
    var formData = new FormData();
    formData.append('file', file);
    $.ajax({
      type: 'POST', processData: false, contentType: false,
      data: formData, url: Server() + 'spares/import.php',
      success: function(data) {
        context.setState({ load: false });
        if (data == 1) {
          alert('Success');
        } else {
          alert('Failed');
        }
      },
      error: function(error) {
        context.setState({ load: false, });
      }
    });
  }

  upload = (e) => {
    document.getElementById('outlined-button-file').click();
  }

  edit(partno, title, tax) {
    this.props.getData(partno, title, tax);
  }

  columnView(val) {
    var x = document.getElementById("myDIV");
    if (val == 0) {
      x.style.display = "block";
      this.setState({ val: 1 })
    }
    else {
      x.style.display = "none";
      this.setState({ val: 0 })
    }
  }

  render() {
    let { fullScreen } = this.props;
    let i = this.props.fromSerialNumber;
    let { dialog, data, sort } = this.state;
    return (
      <div style={{padding: '0.5%'}}>
      <Loading load={this.state.load} message={this.state.message} />
          <div id="myDIV">
            <Grid>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(2)}>
                <input type="checkbox" defaultChecked class="hidecol" id="col_2" />&nbsp;Title
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(3)}>
                <input type="checkbox" class="hidecol" id="col_3" />&nbsp;Local Name
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(4)}>
                <input type="checkbox" class="hidecol" id="col_4" />&nbsp;Tamil Name
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(5)}>
                <input type="checkbox" defaultChecked class="hidecol" id="col_5" />&nbsp;Point
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(6)}>
                <input type="checkbox" defaultChecked class="hidecol" id="col_6" />&nbsp;Tax
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(7)}>
                <input type="checkbox" class="hidecol" id="col_7" />&nbsp;Life&nbsp;
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(8)}>
                <input type="checkbox" class="hidecol" id="col_8" />&nbsp;Min Ord Qty
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(9)}>
                <input type="checkbox" class="hidecol"id="col_9" />&nbsp;From Serial_no
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(10)}>
                <input type="checkbox" class="hidecol" id="col_10" />&nbsp;To Serial_no
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(11)}>
                <input type="checkbox" class="hidecol" id="col_11" />&nbsp;HSN Code
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(12)}>
                <input type="checkbox" defaultChecked class="hidecol" id="col_12" />&nbsp;Weight&nbsp;
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(13)}>
                <input type="checkbox" defaultChecked class="hidecol" id="col_13" />&nbsp;MRP&nbsp;
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} onClick={this.onChangeHiddenColumn(14)}>
                <input type="checkbox" class="hidecol" id="col_14" />&nbsp;Image Count
              </Grid.Column>
              <Grid.Column mobile={5} tablet={5} computer={3} style={{display: this.props.partsedit}} onClick={this.onChangeHiddenColumn(15)}>
                <input type="checkbox" class="hidecol" id="col_15" />&nbsp;Edit
              </Grid.Column>
            </Grid>
          </div>
          <div style={{display: 'flex'}}>
            <Input focus placeholder="search spare name" id="search" icon='search' onChange={this.onChangeText.bind(this)} />
            <Button positive style={{marginLeft: 10}} onClick={ () => { this.props.search(this.state.search) }}>Search</Button>
            <Button negative style={{marginLeft: 10}} onClick={ () => { this.props.getAllSpareDetails(1, 'partno', 'asc') }}>Reset All</Button>
            <Button color='blue' style={{marginLeft: 10}} onClick={this.columnView.bind(this, this.state.val)}>Column View</Button>
            <Button color='blue' onClick={this.exportData.bind(this)} style={{marginLeft: 10}}>Export</Button>
            <Button color='blue' style={{marginLeft: 10}} onClick={ () => { this.setState({ openDialog: true }) } }>Upload</Button>
            <div style={{marginLeft: 10}}><AddSpare menuPermission={this.props.menuPermission} getAllSpareDetails={this.props.getAllSpareDetails} getData={this.props.getData} /></div>
          </div>
        <br/>
        <div id="scrolls">
            <table width="100%" id="emp_table">
                <tr class="tr_header" style={{backgroundColor: '#abb119'}}>
                    <th id='th' style={{width: '5%'}}><center>S.No</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'title')}><center>Title</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'local_name')}><center>Local Name</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'tamil_name')}><center>Tamil Name</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'point')}><center>Point</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'tax')}><center>Tax</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'life')}><center>Life</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'min_order_qty')}><center>Min Ord Qty</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'from_serialno')}><center>From Serial_no</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'to_serialno')}><center>To Serial_no</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'hsn_code')}><center>HSNCode</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'weight')}><center>Weight</center></th>
                    <th id='th' onClick={this.sortData.bind(this, 'mrp')}><center>MRP (Rs.)</center></th>
                    <th id='th'><center>Image Count</center></th>
                    { this.props.menuPermission.edit ?
                      <th id='th'><center>Edit</center></th>:''
                    }
                    
                </tr>
                { data.map((z) => {
                  if (z.title == null || z.title == '') {

                  }
                  else {
                    i++;
                    return (
                      <tr id='tr'>
                        <td id='td'><center>{i}</center></td>
                        <td id='td'>{z.partno+'-->'+z.title+' ('+z.brand+')'}</td>
                        <td id='td'><center>{z.local_name}</center></td>
                        <td id='td'><center>{z.tamil_name}</center></td>
                        <td id='td'><center>{z.points}</center></td>
                        <td id='td'><center>{z.tax+'%'}</center></td>
                        <td id='td'><center>{z.life}</center></td>
                        <td id='td'><center>{z.min_order_qty}</center></td>
                        <td id='td'><center>{z.from_serialno}</center></td>
                        <td id='td'><center>{z.to_serialno}</center></td>
                        <td id='td'>{z.hsn_code}</td>
                        <td id='td'><center>{z.weight}</center></td>
                        <td id='td'><div style={{textAlign: 'right'}}><Mrphistory partno={z.partno} mrp={z.mrp} spareName={z.title} brand_id={z.brand_id} /></div></td>
                        <td id='td'><center>{z.imgcount}</center></td>
                        { this.props.menuPermission.edit ?
                          <td id='td' style={{cursor: 'pointer'}}>
                            <MenuDialog edit={'edit'} menus={this.props.menus} datas={this.props.datas} partsedit={this.props.partsedit} partno={z.partno} title={z.title} />
                          </td>:''
                        }
                      </tr>
                    );
                  }
                }
                )}
            </table>
        </div>
        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}  open={this.state.openDialog}
          onClose={ () => { this.setState({ openDialog: false }) } } aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Excel Format</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div style={{color: 'red'}}>
              <b>NOTE: PLEASE READ CAREFULLY:  YOUR UPLOAD FILE COLUMN ORDER BY BELOW TABLE FORMAT...</b><br/></div>
              <table id='table' width='100%'>
                <tr>
                  <th id='th'>Sino</th>
                  <th id='th'>Partno</th>
                  <th id='th'>Spare Name</th>
                  <th id='th'>Brand Id</th>
                  <th id='th'>HSN CODE</th>
                  <th id='th'>Points</th>
                  <th id='th'>Tax</th>
                  <th id='th'>MRP</th>
                  <th id='th'>DNP</th>
                </tr>
              </table>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <b style={{color: 'blue'}}>Format of File: .CSV (EX: example.csv)</b>
            <input onChange={this.uploadtax} accept=".csv" id="outlined-button-file" type="file" />
           <Button color='blue' onClick={ () => { this.setState({ openDialog: false }) } }>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default View;
